import { render, staticRenderFns } from "./AftermathPage.vue?vue&type=template&id=361bc6fb&"
import script from "./AftermathPage.vue?vue&type=script&lang=js&"
export * from "./AftermathPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports